"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnConfig = void 0;
const react_1 = __importStar(require("react"));
const graphql_1 = require("../../../../../../__generated__/graphql");
const ui_components_1 = require("@groupby/ui-components");
const explanation_cell_1 = require("../partials/explanation-cell");
const reviewed_cell_1 = require("../partials/reviewed-cell");
const products_table_constants_1 = require("../products-table.constants");
const product_table_1 = require("../../../../../common/product-table");
const table_columns_1 = require("../../../../../common/table-columns");
const attributes_1 = require("../../../../../constants/attributes");
const hooks_1 = require("../../../../../preview-products-widget/preview-products-widget-content/products-preview/products-list-view/hooks");
const task_view_1 = require("../../../../../store/catalogs/task-view");
const localization_1 = require("../../../../../../localization");
const useColumnConfig = ({ attributeId, onActiveProductIdChange, isCellLoading, isRowDisabled, onReviewStatusChange, }) => {
    var _a;
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const rowSize = (0, task_view_1.useTaskViewProductsTableRowSize)();
    const productsTableColumnsConfig = (0, hooks_1.useProductsTableColumnsConfig)({
        onActiveProductIdChange,
        rowSize,
        isCellLoading,
        isClassificationEditable: false,
    });
    const parsed = attributeId ? (0, table_columns_1.parseColumnId)(attributeId) : null;
    const attributeName = parsed === null || parsed === void 0 ? void 0 : parsed.label;
    const isMeasure = (_a = parsed === null || parsed === void 0 ? void 0 : parsed.dataMeta) === null || _a === void 0 ? void 0 : _a.isMeasure;
    return (0, react_1.useMemo)(() => {
        const nameColumn = productsTableColumnsConfig.find((column) => column.field === 'name');
        nameColumn.width = 250;
        if (!attributeId) {
            return productsTableColumnsConfig;
        }
        return [
            ...productsTableColumnsConfig,
            {
                field: products_table_constants_1.REVIEWED_COLUMN_ID,
                type: 'custom',
                align: 'center',
                headerName: t({ key: 'HLQA_STATUS_REVIEWED' }),
                width: 132,
                minWidth: 132,
                resizable: false,
                editable: false,
                sortable: true,
                filterable: true,
                filterOperators: (0, ui_components_1.createListFilterOperators)({
                    allowedOperators: [ui_components_1.ListFilterOperatorTypes.IsAnyOf],
                    inputProps: {
                        groupActions: false,
                        searchable: false,
                        showOperatorSelect: false,
                        options: [
                            { label: t({ key: 'HLQA_STATUS_REVIEWED' }), value: 'Reviewed' },
                            { label: t({ key: 'HLQA_STATUS_NOT_REVIEWED' }), value: 'NotReviewed' },
                        ],
                    },
                }),
                renderHeader: (0, product_table_1.getColumnHeader)(products_table_constants_1.REVIEWED_COLUMN_ID),
                renderCell: ({ row }) => (react_1.default.createElement(reviewed_cell_1.ReviewedCell, { reviewed: row[products_table_constants_1.REVIEWED_COLUMN_ID], attribute: attributeName, disabled: isRowDisabled === null || isRowDisabled === void 0 ? void 0 : isRowDisabled(row), attributeType: attributeId === attributes_1.CustomProductAttributes.ClassificationProductType
                        ? graphql_1.ProductAttributeType.Category
                        : isMeasure
                            ? graphql_1.ProductAttributeType.Measure
                            : graphql_1.ProductAttributeType.Label, productId: row.id, onReviewStatusChange: onReviewStatusChange })),
            },
            {
                field: products_table_constants_1.EXPLANATION_COLUMN_ID,
                align: 'center',
                headerName: t({ key: 'PRODUCT_EXPLANATION' }),
                width: 192,
                minWidth: 192,
                flex: 1,
                resizable: true,
                editable: false,
                filterable: false,
                renderHeader: (0, product_table_1.getColumnHeader)(products_table_constants_1.EXPLANATION_COLUMN_ID),
                renderCell: ({ row }) => { var _a, _b; return (react_1.default.createElement(explanation_cell_1.ExplanationCell, { rowSize: rowSize, explanations: (_b = (_a = row.productAttributesExplanations) === null || _a === void 0 ? void 0 : _a[attributeName]) !== null && _b !== void 0 ? _b : [] })); },
            },
        ];
    }, [
        productsTableColumnsConfig,
        t,
        attributeName,
        isMeasure,
        attributeId,
        rowSize,
        isRowDisabled,
        onReviewStatusChange,
    ]);
};
exports.useColumnConfig = useColumnConfig;
